import { useMatches } from '@remix-run/react';

export type LayoutHandle = {
    layoutTitleKey?: string | ((data: unknown) => string);
};

export function useLayoutTitleKey(fallback?: string) {
    const matches = useMatches();
    const deepest = [ ...matches ].reverse().find(
        (m) => (m.handle as LayoutHandle | undefined)?.layoutTitleKey !== undefined
    );

    if (!deepest) {
        return fallback;
    }

    const handle = deepest.handle as LayoutHandle;
    const lt = handle.layoutTitleKey!;
    return typeof lt === 'function' ? lt(deepest.data) : lt;
}
